import "swiper/css";
import About from "@/Components/Homepage/About/About";
import Landing from "@/Components/Homepage/Landing";
import Services from "@/Components/Homepage/Services";
import SiteLayout from '@/Components/Layouts/SiteLayout';
import ContactForm, { OpenStyle } from '@/Components/ContactForm/ContactForm';
import Testimonials, { type TestimonialData } from "@/Components/Homepage/Testimonials";
import { useIsClient } from 'usehooks-ts';

type Props = {
    testimonials: TestimonialData[],
}

export default function HomepagePage({ testimonials }: Props) {
    const isClient = useIsClient();

    return <>
        {isClient && <SiteLayout className="text-brand">
            <ContactForm openStyle={OpenStyle.SLIDE_TOP}/>
            <Landing />
            <About />
            <Services />
            <Testimonials testimonials={testimonials} />
        </SiteLayout>}
    </>
}
